module.exports = __webpack_public_path__ + "static/linda-ichiyama-logo-4f2df20136c66b840ba19d2ed7d41290.png";